import { fuelTankTypesEnum } from "helpers/enums";

const dieselFuelTank = {
    minimumVolume: 0,
    currentVolume: 0,
    totalVolume: 0,
    fuelConsumption: 33,
    minimumFuelTankVolume: 120,
    type: fuelTankTypesEnum.Diesel,
};

const gasFuelTank = {
    minimumVolume: 0,
    currentVolume: 0,
    totalVolume: 0,
    fuelConsumption: 33,
    minimumFuelTankVolume: 120,
    type: fuelTankTypesEnum.Gas,
};

export { dieselFuelTank, gasFuelTank };
